<template>
    <div>
        <b-card no-body v-show="mostrarRespostas">
            <b-card-header>
                <span class="h5">RESPOSTAS ÀS PESQUISAS</span>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblRespostas"
                    :itens="respostas"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="respondidaPor" slot-scope="data">
                        <span v-if="data.usuario">{{ data.usuario }}</span>
                        <span v-if="data.fornecedor"
                            ><br /><small>{{ data.fornecedor }}</small></span
                        >
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span class="text-primary">
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Visualizar"
                                @click.stop="
                                    visualizarRespostas(data.respostaId)
                                "
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import PesquisasServicos from './PesquisasServicos'

export default {
    components: {},

    data() {
        return {
            respostas: [],
            campos: [
                {
                    key: 'pesquisa',
                    label: 'Pesquisa',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'respondidaPor',
                    label: 'Respondida por',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Enviada em',
                    sortable: true,
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },

    methods: {
        visualizarRespostas(id) {
            this.$router.push({
                name: 'Pesquisas_Respostas_Detalhar',
                params: {
                    respostaId: id
                }
            })
        },

        obterRespostas() {
            this.$store.dispatch('addRequest')
            PesquisasServicos.obterRespostas(1).then(response => {
                if (response) {
                    if (response.success) {
                        this.respostas = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter as Mensagens',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterRespostas()
    },

    computed: {
        mostrarRespostas() {
            return this.$route.name == 'Pesquisas_Respostas'
        }
    },

    watch: {}
}
</script>
